import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";
import Page from "@/views/Page.vue";
import Offers from "@/views/Offers";
import Profile from "@/views/Profile";
import MyOffers from "@/views/MyOffers";
import NewAppointment from "@/views/NewAppointment";
import NewReservation from "@/views/NewReservation";
import MyAppointments from "@/views/MyAppointments";
import MyAppointmentDetail from "@/views/MyAppointmentDetail";
import MyReservationDetail from "@/views/MyReservationDetail";
import store from '@/store/store.js'


Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/logout",
      name: "logout",
      component: Login
    },
    {
      path: "/page/:identifier",
      name: "page",
      component: Page,
      props: true
    },
    {
      path: "/offers",
      name: "offers",
      component: Offers,
      meta: { auth: true }
    },
    {
      path: "/my-offers",
      name: "my-offers",
      component: MyOffers,
      meta: { auth: true }
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: { auth: true }
    },
    {
      path: "/my-appointments",
      name: "my-appointments",
      component: MyAppointments,
      meta: { auth: true }
    },
    {
      path: "/my-appointments/:id",
      name: "appointmentdetails",
      component: MyAppointmentDetail,
      meta: { auth: true }
    },
    {
      path: "/my-appointments/reservation/:id",
      name: "reservationdetails",
      component: MyReservationDetail,
      meta: { auth: true }
    },
    {
      path: "/new-appointment",
      name: "new-appointment",
      component: NewAppointment,
      meta: { auth: true }
    },
    {
      path: "/new-reservation",
      name: "new-reservation",
      component: NewReservation,
      meta: { auth: true }
    },

    // otherwise redirect to error page
    { path: "*", redirect: "/" }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    const user = localStorage.getItem("user");
    if (!user) {
      next({ name: "login" });
      return;
    }
  }
  if (to.meta.role_id) {
    if (to.meta.role_id !== store.state.user.user.role_id) {
      return;
    }
  }
  next();
});

export default router;
